export default "__VITE_ASSET__9a456201__"